<template>
  <div class="grid gap-4 lg:grid-cols-3 grid-cols-2">
    <ChallengeTile
      v-for="challenge in challenges"
      :id="challenge.mappingId || challenge.id || challenge.challengeMappingId"
      :key="challenge.id"
      :category="challenge.category"
      :activity-type="challenge.activityType"
      :comp-type="challenge.competitiveChallengeType"
      :image="challenge.image"
      :title="challenge.title"
      :grid-type="gridType"
      :start-date="
        gridType === 'active' ? getStartDate(challenge) : challenge.startDate
      "
      :end-date="challenge.endDate"
    >
    </ChallengeTile>
  </div>
</template>
<script setup lang="ts">
import ChallengeTile from "./ChallengeTile.vue";
import { CustomChallengeListViewDto } from "../../../dto/custom-challenge-list-view.dto.ts";
import { ChallengeType } from "../../../enum/v2/challengeType.ts";

defineProps({
  challenges: {
    type: Array as PropType<CustomChallengeListViewDto[]>,
    required: true,
  },
  gridType: {
    type: String as PropType<"active" | "all" | "history">,
    required: true,
  },
});

function getJoinedAt(challenge): string | undefined {
  if (challenge.competitiveChallengeTeams) {
    const team = challenge.competitiveChallengeTeams.find(
      (team) => team.isTeamOfCurrentUser
    );
    return team ? team.joinedAt : undefined;
  }
  return undefined;
}

function getStartDate(challenge): string {
  if (challenge.category === ChallengeType.COMPETITIVE_CHALLENGE) {
    return getJoinedAt(challenge);
  }
  return challenge.userStartAt;
}
</script>
